import { Inline, TextDropdown, Text } from 'braid-design-system';
import React from 'react';

interface Props {
  value: 'Date posted' | 'Date saved';
  onChange: (value: 'Date posted' | 'Date saved') => void;
}

const SortDropdown = ({ value, onChange }: Props) => (
  <Inline space="small" align="right" alignY="center">
    <Text size="small">Sorted by</Text>
    <Text size="small" weight="strong">
      <TextDropdown
        id="profile-saved-listing-sort-dropdown"
        value={value}
        options={['Date saved', 'Date posted']}
        onChange={onChange}
        label="Select"
      />
    </Text>
  </Inline>
);

export default SortDropdown;
